import React from 'react';
import { withRouter } from 'react-router-dom';
import { FlexContainer, Title } from '../common/StyledComponents';

const categories = [
  {
    slug: 'best-of/mobiles',
    url:
      'http://206.189.23.252/wp-content/uploads/2018/07/batman_knight-wallpaper-1920x1080.jpg',
    postData: {
      postTitle: 'Best Mobiles'
    }
  },
  {
    slug: 'best-of/laptops',
    url:
      'http://206.189.23.252/wp-content/uploads/2018/07/batman_knight-wallpaper-1920x1080.jpg',
    postData: {
      postTitle: 'Best PCs/Laptops'
    }
  },
  {
    slug: 'best-of/softwares',
    url:
      'http://206.189.23.252/wp-content/uploads/2018/07/batman_knight-wallpaper-1920x1080.jpg',
    postData: {
      postTitle: 'Best Softwares'
    }
  },
  {
    slug: 'best-of/accessories',
    url:
      'http://206.189.23.252/wp-content/uploads/2018/07/batman_knight-wallpaper-1920x1080.jpg',
    postData: {
      postTitle: 'Best Accessories'
    }
  },
  {
    slug: 'best-of/alternatives',
    url:
      'http://206.189.23.252/wp-content/uploads/2018/07/batman_knight-wallpaper-1920x1080.jpg',
    postData: {
      postTitle: 'Best Alternatives'
    }
  }
];

const navigate = (history, postSlug) => {
  // console.log('postSlug: ', postSlug);
  history.push(`/${postSlug}`);
};

const categoryCards = history => {
  return categories.map((category, key) => {
    return (
      <FlexContainer
        className="Card justify-center items-end pa3"
        key={key}
        onClick={() => navigate(history, category.slug)}
        width={'160px'}
        height={'90px'}
        borderradius="5px"
        margin={key === 0 ? '0' : '0 0 0 10px'}
        background={`url(${category.url})`}
        postData={category.postData}
      >
        <Title
          className="card-title"
          fontFamily="Montserrat"
          fontSize="1rem"
          fontstyle="bold"
          color="#fff"
        >
          {category.postData.postTitle}
        </Title>
      </FlexContainer>
    );
  });
};

const Categories = props => {
  return (
    <FlexContainer className="flex justify-center">
      <FlexContainer
        className="mt3 mh2 justify-center"
        style={{ width: '95%', maxWidth: '1040px' }}
      >
        {categoryCards(props.history)}
      </FlexContainer>
    </FlexContainer>
  );
};

export default withRouter(Categories);
